// Sample placeholder transformation. Replace with real, consented
// member before/after photos and details.
const transformations = [
  {
    id: "tr1",
    name: "Sample Member",
    duration: "12 weeks (placeholder)",
    details: "Combined strength training with guided nutrition coaching.",
    disclaimer: "Individual results may vary. Placeholder entry pending client-approved content.",
  },
];

export default transformations;
